<template>
    <div type="button" @click.stop="removeImage"
        class="absolute m-auto  text-white  z-30   flex items-center justify-center w-full h-full bg-black/15 rounded-lg">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-8 hover:scale-110 transition duration-200">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>

    </div>
    <img :src="props.photo" class="h-full w-full object-cover rounded-lg border" />
</template>


<script setup>
import { defineEmits, defineProps } from 'vue';


const props = defineProps({
    photo: {
        type: String,
        required: true
    }
    
})

const emits = defineEmits(['removeImage'])


const removeImage = () => {

    
    emits("removeImage");
}


</script>